import { useTriggerAction } from '@libs/hooks';
import { ActionActionTypeEnum, TCommonData, TGroupWidgetProps } from '@libs/types';
import { useEffect, useEffectEvent } from 'react';
import { ActionWidgetEnum } from '../../types/enums';

export const Action = ({ widget }: TGroupWidgetProps<TCommonData, ActionWidgetEnum>) => {
    const { triggerActionsByType } = useTriggerAction(widget);

    const onTriggerActionsByType = useEffectEvent(() => {
        return triggerActionsByType(ActionActionTypeEnum.onTimer);
    });

    useEffect(() => {
        onTriggerActionsByType().then();
    }, []);

    return false;
};
